

import React, { memo } from 'react';
import cn from 'classnames';
import '../styles/text-button.scss';








const TextButton = ({
  className,
  children,
  isDisabled,
  onClick
}) =>
<button
  type="button"
  className={cn(
    'text-button',
    { 'text-button--disabled': isDisabled },
    className
  )}
  disabled={isDisabled}
  onClick={onClick}>

    {children}
  </button>;


export default memo(TextButton);